'use strict';

var classes = {"progress":"progress__HAcbd","circle":"circle__xUQW7","completed":"completed__VNsZ-","in-progress":"in-progress__FQBOU","not-started":"not-started__h2cMI"};

module.exports = classes;
//# sourceMappingURL=progress-status.module.scss.js.map
